import { render, staticRenderFns } from "./orderStatementOrdersSummaryBox.vue?vue&type=template&id=1f36eb4c&"
import script from "./orderStatementOrdersSummaryBox.vue?vue&type=script&lang=ts&"
export * from "./orderStatementOrdersSummaryBox.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports